import PropTypes from 'prop-types'
import { Checkbox, HStack, Text, VStack } from '@chakra-ui/react'
import React from 'react'
import { useLabels } from '../../../../utils/hooks/useLabels/useLabels'
import { colors } from '../../../../utils/theme/styles'

export default function Benefits({ data }) {
  const { texts } = useLabels()
  return (
    <VStack spacing="15px" alignItems="flex-start">
      <Text color={colors.gray[400]} variant="subtitle3">
        {texts.contracted_benefits}
      </Text>
      <HStack>
        <Checkbox isDisabled isChecked={data.bAlimentacion}>
          Alimentación
        </Checkbox>
        <Checkbox isDisabled isChecked={data?.bSalaCuna}>
          Amibaby
        </Checkbox>
      </HStack>
    </VStack>
  )
}

Benefits.propTypes = {
  data: PropTypes.shape({
    bAlimentacion: PropTypes.bool,
    bSalaCuna: PropTypes.bool,
  }),
}
